import React from "react";
import { ParamCheckboxStyle } from "./Index";

const ParamFilter = ({
  paramsList,
  isSelected,
  handleParameterSelect,
  getDisplayLabel = (label) => label,
}) => {
  return (
    <>
      {paramsList?.map(([key]) => (
        <ParamCheckboxStyle key={key}>
          <input
            type="checkbox"
            checked={isSelected(key)}
            onChange={() => handleParameterSelect(key)}
          />
          <label>{getDisplayLabel(key)}</label>
        </ParamCheckboxStyle>
      ))}
    </>
  );
};

export default ParamFilter;
